export default __webpack_public_path__ + "31a35131d1756060ce1e8ab7274d77bd.png";